module.exports = __webpack_public_path__ + "img/sw6.b36cd992.png";